module.exports = __webpack_public_path__ + "fonts/gothica1-semibold-webfont.d76fbf0.woff";